<template>
  <div class="min-h-screen">
    <NavBar :signed-in="signedIn" :user-name="userName" active-page="" />

    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 class="text-2xl font-bold text-gray-900 mb-6">{{ t('privacy.title') }}</h1>
      <p class="text-xs text-gray-400 mb-6">{{ t('privacy.last_updated') }}: 04.05.2026</p>

      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6">

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.intro_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('privacy.intro_text') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.collect_title') }}</h2>
          <p class="text-sm text-gray-600 mb-2">{{ t('privacy.collect_text') }}</p>
          <ul class="text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>{{ t('privacy.collect_email') }}</li>
            <li>{{ t('privacy.collect_name') }}</li>
            <li>{{ t('privacy.collect_photo') }}</li>
            <li>{{ t('privacy.collect_profile') }}</li>
          </ul>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.facebook_title') }}</h2>
          <p class="text-sm text-gray-600 mb-2">{{ t('privacy.facebook_text') }}</p>
          <ul class="text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>{{ t('privacy.facebook_email') }}</li>
            <li>{{ t('privacy.facebook_name') }}</li>
            <li>{{ t('privacy.facebook_photo') }}</li>
          </ul>
          <p class="text-sm text-gray-600 mt-2">{{ t('privacy.facebook_purpose') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.google_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('privacy.google_text') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.purpose_title') }}</h2>
          <ul class="text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>{{ t('privacy.purpose_auth') }}</li>
            <li>{{ t('privacy.purpose_profile') }}</li>
            <li>{{ t('privacy.purpose_communication') }}</li>
          </ul>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.storage_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('privacy.storage_text') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.sharing_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('privacy.sharing_text') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.rights_title') }}</h2>
          <ul class="text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>{{ t('privacy.rights_access') }}</li>
            <li>{{ t('privacy.rights_edit') }}</li>
            <li>{{ t('privacy.rights_delete') }}</li>
          </ul>
          <p class="text-sm text-gray-600 mt-2">
            {{ t('privacy.rights_delete_link') }}
            <a href="/data-deletion" class="text-blue-700 hover:underline">{{ t('privacy.rights_delete_page') }}</a>
          </p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('privacy.contact_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('privacy.contact_text') }}</p>
          <p class="text-sm text-blue-700 mt-1">admin@alerg.eu</p>
        </section>

      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import NavBar from './NavBar.vue'

const props = defineProps({ signedIn: Boolean, userName: String })
const { t } = useI18n()
</script>
